(() => {
  if (window.BellziPatchMotion) return;
  window.BellziPatchMotion = true;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const selector = '.patch-stage:not(.patch-event), .patch-bold .patch-hero, .patch-bold .patch-original__heading, .patch-bold .patch-original__first, .patch-bold .patch-original__second';
  let observer;
  function stop() {
    if (observer) observer.disconnect();
    document.querySelectorAll('.patch-motion-play').forEach(node => node.classList.remove('patch-motion-play'));
  }
  function init(root = document) {
    if (preference.matches || !('IntersectionObserver' in window)) return;
    if (!observer) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || preference.matches) return;
        entry.target.classList.add('patch-motion-play');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    const targets = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) targets.unshift(root);
    targets.forEach(node => {
      if (seen.has(node)) return;
      seen.add(node);
      observer.observe(node);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(node => observer?.unobserve(node));
  });
  preference.addEventListener('change', stop);
})();
